var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowStrokeDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FA6400",
    fillRule: "evenodd",
    d: "M1199.32373,92.0416667 L1203.97437,96.692301 C1204.39743,97.115369 1204.39743,97.8012977 1203.97437,98.2243657 C1203.5513,98.6474337 1202.86537,98.6474337 1202.4423,98.2243657 L1197.02563,92.807699 C1196.60257,92.384631 1196.60257,91.6987023 1197.02563,91.2756343 L1202.4423,85.8589677 C1202.86537,85.4358997 1203.5513,85.4358997 1203.97437,85.8589677 C1204.39743,86.2820356 1204.39743,86.9679644 1203.97437,87.3910323 L1199.32373,92.0416667 Z",
    transform: "rotate(-90 559.5 645.042)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowStrokeDown);
export default __webpack_public_path__ + "static/media/arrow_stroke_down.ef5d3ef2851943b5b7631cff7d608b00.svg";
export { ForwardRef as ReactComponent };